export interface Interaction {
  timestamp: number;
  sent_connections: number;
  accepted_connections: number;
  sent_messages: number;
  sent_inmails: number;
  replies: number;
  views: number;
}
export interface Styling {
  label: string;
  color?: string;
  color_background?: string;
  icon?: string;
  tooltip? : string;
}
export interface Flow {
  id: string;
  type: string;
  name: string;
  metrics: Interaction;
}
export interface Campaign {
  id: string;
  state: string;
  name: string;
  // ENG-7969: campaign `type`, `audience_size` and `target_count` are gone from
  // the campaign response. `lead_count` (the campaign's target total) replaces
  // `target_count`, and the report shows `list_name` where the type used to be —
  // null for a campaign on an implicit list.
  outreach_type: string;
  list_name: string | null;
  lead_count: number;
  created_at: number;
  metrics: Interaction;
  completion: number;
  flows: Array<Flow>;
}
export interface CampaignResponse {
  status: string;
  campaign: Campaign;
}
export interface ReportParameters {
  account_ids: Array<string>;
  from: number;
  to: number;
}
export interface DroppedCampaign {
  id: string | null;
  name: string | null;
}
export interface ReportData {
  parameters: ReportParameters;
  interactions: Array<Interaction>;
  campaigns: Array<Campaign>;
  droppedCampaigns: Array<DroppedCampaign>;
}
export interface LinkedInProfile {
  id: string;
  full_name: string;
  first_name: string;
  last_name: string;
  public_identifier: string;
  picture_url: string;
  occupation: string;
  urn: string;
  email: string;
  premium: boolean;
  location?: Location;
}
interface Location {
  name: string;
  urn: string;
}
export interface WorkspaceLicense {
  account_id?: string;
  expires_at: number;
  status: "active" | "non_renewing";
  lifetime?: boolean;
  source: "aimfox" | "appsumo" | "ltd";
}

export type WorkspaceAccount = LinkedInProfile & {
  state: "LoggedIn" | "LoggedOut" | "NeverLoggedIn";
  license: WorkspaceLicense;
};

export type ProfileData = LinkedInProfile & {
  first_scraped_at: Date;
  last_scraped_at: Date;
};
export interface LoginError {
  code: number;
  name: string;
  serverMessage: string;
  type: string;
}
export interface LoginResponse {
  challenge_type: string;
  login_result: string;
  profile: ProfileData;
  status: string;
}
export interface Customization {
  name: string;
  logo: string;
  primary_color: string;
  use_chrome_extension: boolean;
  extension_id: string;
}
export interface LoginProxy {
  country_code: string;
  custom_proxies: CustomProxy[];
  countries: Country[];
}

export interface CustomProxy {
  id: string;
  code: string;
  name: string;
  location: ProxyLocation;
}

export interface ProxyLocation {
  city: string;
  countryISO: string;
}

export interface Country {
  code: string;
  name: string;
  dial_code?: string;
}
// Define the enum for login states
export enum LoginState {
  LOGIN = "LOGIN",
  CHALLENGE = "CHALLENGE",
  PASS = "PASS",
  ERROR = "ERROR",
  BAD_PASSWORD = "BAD_PASSWORD"
}
export enum ChallengeType {
  EmailPinChallenge = "EmailPinChallenge",
  SMSPinChallenge = "SMSPinChallenge",
  CaptchaChallenge = "CaptchaChallenge",
  DHomePageGuest = "d_homepage-guest-home",
  AppChallenge = "AppChallenge",
  AuthenticatorAppChallenge = "AuthenticatorAppChallenge",
  PhoneChallenge = "PhoneChallenge",
  RestrictedChallenge = "RestrictedChallenge"
}
export enum LoginType {
  EMAIL = "EMAIL",
  EXTENSION = "EXTENSION",
  SELECT_PROXY = "SELECT_PROXY"
}
